import "vant/es/notify/style";
import _Notify from "vant/es/notify";
import _objectSpread from "E:/Deepin/Projects/spring-activity/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "E:/Deepin/Projects/spring-activity/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "vant/es/loading/style";
import _Loading from "vant/es/loading";
import "vant/es/image/style";
import _Image from "vant/es/image";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "vant/es/empty/style";
import _Empty from "vant/es/empty";
import "vant/es/nav-bar/style";
import _NavBar from "vant/es/nav-bar";
import "vant/es/button/style";
import _Button from "vant/es/button";
import "vant/es/skeleton/style";
import _Skeleton from "vant/es/skeleton";
import "vant/es/pull-refresh/style";
import _PullRefresh from "vant/es/pull-refresh";
import "vant/es/list/style";
import _List from "vant/es/list";

var _components;

import "core-js/modules/es.function.name.js";
import { mapState, mapMutations } from "vuex";
import Header from "../components/Header";
import help from "../assets/js/help.js";
import MyRedPacket from "../components/MyRedPacket";
import ListWrapper from "../components/ListWrapper";
import ListOtherActivityWrapper from "../components/ListOtherActivityWrapper";
import ListInvitedWrapper from "../components/ListInvitedWrapper";
import ListJoinWrapper from "../components/ListJoinWrapper";
import bus from "vue3-eventbus";
export default {
  name: "Index",
  components: (_components = {}, _defineProperty(_components, _List.name, _List), _defineProperty(_components, _PullRefresh.name, _PullRefresh), _defineProperty(_components, _Skeleton.name, _Skeleton), _defineProperty(_components, _Button.name, _Button), _defineProperty(_components, _NavBar.name, _NavBar), _defineProperty(_components, _Empty.name, _Empty), _defineProperty(_components, _Toast.name, _Toast), _defineProperty(_components, _Image.name, _Image), _defineProperty(_components, _Loading.name, _Loading), _defineProperty(_components, "Header", Header), _defineProperty(_components, "MyRedPacket", MyRedPacket), _defineProperty(_components, "ListWrapper", ListWrapper), _defineProperty(_components, "ListOtherActivityWrapper", ListOtherActivityWrapper), _defineProperty(_components, "ListInvitedWrapper", ListInvitedWrapper), _defineProperty(_components, "ListJoinWrapper", ListJoinWrapper), _components),
  data: function data() {
    return {
      border: false,
      finished: false,
      refreshing: false,
      isLogin: false,
      loading: true,
      loadDate: false,
      emptyImage: require("@/assets/images/content-null.png"),
      timer: "",
      listArray: [0, 1, 2, 3, 4, 5, 6],
      show: false,
      invitedList: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(["uid", "token", "time", "isTest", "totalIngral", "type", "activeIndex", "isSelected", "shareTitle", "shareDesc", "shareImage", "loadingBanner", "bannerImage"])), {}, {
    isDevelopment: function isDevelopment() {
      return process.env.NODE_ENV === "development";
    },
    params: function params() {
      return {
        "uid": this.uid - 0
      };
    },
    title: function title() {
      return this.shareTitle || "每日抢积分 邀请送豪礼";
    }
  }),
  watch: {
    shareTitle: function shareTitle(value) {
      document.title = value;
    }
  },
  methods: _objectSpread(_objectSpread({}, mapMutations(["setUid", "setTotalIngral", "setAppInfo", "setIsSelected", "setType", "setActiveIndex", "setHomeReset"])), {}, {
    resetActivityIndex: function resetActivityIndex(index) {
      if (this.isLogin) {
        this.setActiveIndex(index);
      } else {
        this.setType(4);
        this.setActiveIndex(index);
      }
    },
    onClickInfo: function onClickInfo() {
      if (!isInApp()) {
        help.openApp("");
        return;
      }

      console.log(1);

      if (this.isLogin) {
        window.dailyPointsTask();
      } else {
        this.setType(1);
        this.onClickCreate();
      }
    },
    onClickShop: function onClickShop() {
      if (!isInApp()) {
        help.openApp("");
        return;
      }

      if (this.isDevelopment) {
        window.location.href = "/shop";
      } else {
        if (this.isLogin) {
          window.location.href = "/shop";
        } else {
          this.setType(2);
          this.onClickCreate();
        }
      }
    },
    cancelActivity: function cancelActivity() {
      var _this = this;

      this.axios.post("/api/activity/invitation-del").then(function (res) {
        if (res) {
          help.requestSuccess(res, true).then(function (res) {
            console.log(res);
          }, function (err) {
            console.log(err);
            help.resError(err, true, _this.logout, _this.setTimeOut);
          });
        }
      }, function (err) {
        help.requestError(err);
      });
    },
    myJoinList: function myJoinList() {
      var _this2 = this;

      this.axios.get("/api/activity/invitation-my-list").then(function (res) {
        if (res) {
          help.requestSuccess(res, true).then(function (res) {
            console.log(res);
          }, function (err) {
            console.log(err);
            help.resError(err, true, _this2.logout, _this2.setTimeOut);
          });
        }
      }, function (err) {
        help.requestError(err);
      });
    },
    updateJoinInfo: function updateJoinInfo() {
      var _this3 = this;

      this.axios.post("/api/activity/invitation-update").then(function (res) {
        if (res) {
          help.requestSuccess(res, true).then(function (res) {
            console.log(res);
          }, function (err) {
            console.log(err);
            help.resError(err, true, _this3.logout, _this3.setTimeOut);
          });
        }
      }, function (err) {
        help.requestError(err);
      });
    },
    myInvitation: function myInvitation() {
      var _this4 = this;

      this.axios.get("/api/activity/my-invitation-user-list").then(function (res) {
        if (res) {
          help.requestSuccess(res, true).then(function (res) {
            console.log(res);
          }, function (err) {
            console.log(err);
            help.resError(err, true, _this4.logout, _this4.setTimeOut);
          });
        }
      }, function (err) {
        help.requestError(err);
      });
    },
    getRedpacketInfo: function getRedpacketInfo() {
      var _this5 = this;

      this.axios.get("/api/activity/redpacket-config").then(function (res) {
        if (res) {
          help.requestSuccess(res, false).then(function (res) {
            console.log(res);
          }, function (err) {
            console.log(err);
            help.resError(err, true, _this5.logout, _this5.setTimeOut);
          });
        }
      }, function (err) {
        help.requestError(err);
      });
    },
    getRedpacket: function getRedpacket() {
      var _this6 = this;

      this.axios.get("/api/activity/redpacket-record-add").then(function (res) {
        if (res) {
          help.requestSuccess(res, true).then(function (res) {
            console.log(res);
          }, function (err) {
            console.log(err);
            help.resError(err, true, _this6.logout, _this6.setTimeOut);
          });
        }
      }, function (err) {
        help.requestError(err);
      });
    },
    getRedpacketRecord: function getRedpacketRecord() {
      var _this7 = this;

      var id = this.info.id;
      this.axios.get("/api/activity/redpacket-record-list?id=".concat(id)).then(function (res) {
        if (res) {
          help.requestSuccess(res, true).then(function (res) {
            console.log(res);
          }, function (err) {
            console.log(err);
            help.resError(err, true, _this7.logout, _this7.setTimeOut);
          });
        }
      }, function (err) {
        help.requestError(err);
      });
    },
    getOtherActivityList: function getOtherActivityList() {
      var _this8 = this;

      this.axios.get("/api/topic/activity-list?size=3&type=2&status=0").then(function (res) {
        if (res) {
          help.requestSuccess(res, true).then(function (res) {
            console.log(res);
          }, function (err) {
            console.log(err);
            help.resError(err, true, _this8.logout, _this8.setTimeOut);
          });
        }
      }, function (err) {
        help.requestError(err);
      });
    },
    registered: function registered() {
      var _this9 = this;

      this.axios.get("/api/h5/mobile-registered-hd?mobile=13467077567&applicationId=2&invite_mobile=13467077567&yzm=1111'").then(function (res) {
        if (res) {
          help.requestSuccess(res, true).then(function (res) {
            console.log(res);
          }, function (err) {
            console.log(err);
            help.resError(err, true, _this9.logout, _this9.setTimeOut);
          });
        }
      }, function (err) {
        help.requestError(err);
      });
    },
    getIntegral: function getIntegral() {
      if (!this.totalIngral) {
        this.setTotalIngral(50000);
      }
    },
    onClickCreate: function onClickCreate() {
      getUserInfo();
      console.log(2);
    },
    getAppInfo: function getAppInfo(param) {
      console.log(param);
      this.loading = false;

      if (param) {
        this.setAppInfo(JSON.parse(param));

        if (this.uid && this.token) {
          this.isLogin = true;

          if (this.type === 1) {
            this.onClickInfo();
          } else if (this.type === 2) {
            this.onClickShop();
          } else if (this.type === 3) {
            this.joinActivity();
          }
        }
      } else {
        this.isLogin = false;

        _Notify({
          type: "warning",
          message: "请登录后重试!"
        });

        console.log("请登录后重试!");
      }
    },
    joinActivity: function joinActivity() {
      console.log("buson");
      bus.emit("joinActivity");
    },
    initShare: function initShare() {
      var _document$querySelect;

      var param = {
        "title": document.title,
        "imgUrl": "https://www.d1ev.com/special/circle/images/share-2.png",
        "description": ((_document$querySelect = document.querySelector("meta[name='description']")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.content) || "",
        "url": window.location.href
      };
    },
    getInvitedList: function getInvitedList() {
      var _this10 = this;

      this.axios.get("/api/activity/invitation-list?uid=".concat(this.params.uid)).then(function (res) {
        if (res) {
          help.requestSuccess(res, true).then(function (res) {
            console.log(res);
            _this10.invitedList = res;
          }, function (err) {
            console.log(err);
          });
        }
      }, function (err) {
        console.log(err);
      });
    }
  }),
  created: function created() {
    window.registerUserInfo = this.getAppInfo;
  },
  mounted: function mounted() {
    if (this.isDevelopment) {}
  }
};